/* eslint-disable react/prop-types */
import classes from './Frame.module.scss' ;


function Frame({fContent ,fTitle , fImg}) {

    return (
        <section className={`${classes["section__container"]} `}>
        <p className={classes["section__subheader"]}>{fTitle}</p>
        <p className={classes["__strong"]}>
            {fContent}
        </p>
        <div className={`${classes["container"]} `}>
            <img src={fImg} alt="img" className='img-fluid' loading="lazy"/>
        </div>
    </section>
    )
}

export default Frame
